export default __webpack_public_path__ + "static/media/tailFInHeaderIcon.1b5ac2d2.svg";